import styled from 'styled-components'
import ArticleCard from '../ArticleCard';

const PrimeGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 15vh);

    background: #C6BCAB;

    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 48px;

    border: 1px solid black;
    line-height: 13vh;


    .P {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
    }
    .R {
        grid-row: 1;
        grid-column: 2;
        border: inherit;

    }

    .I {
        grid-row: 2;
        grid-column: 2;
        border: inherit;
        border-bottom: 0px solid black;

    }

    .M {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
        border-bottom: 0px solid black;
    }
    .E {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
        border-bottom: 0px solid black;
    }

    .Blank1 {
        grid-row: 1;
        grid-column: 3;
        border: inherit;
        
    }
    .Blank2 {
        grid-row: 1;
        grid-column: 4;
        border: inherit;
    }
    .Blank3 {
        grid-row: 2;
        grid-column: 1;
        border: inherit;
        border-bottom: 0px solid black;
    }

`;

const ArticleGrid = styled("div")`
    background: #C6BCAB;

`

const PrimeMobile = (props) => {
    let a1 = props.prime[0];
    return (
        <>
            <PrimeGrid>
                <div class="P">P</div>
                <div class="R">R</div>
                <div class="I">I</div>
                <div class="M">M</div>
                <div class="E">E</div>

                <div class="Blank1"></div>
                <div class="Blank2"></div>
                <div class="Blank3"></div>

            </PrimeGrid>
            <ArticleGrid>
                <div class="A1">
                    <ArticleCard
                        position='right'
                        article_title={a1.article_title}
                        article_byline={a1.article_byline}
                        article_image={a1.article_image} article_url={a1.article_url}></ArticleCard>
                </div>
            </ArticleGrid>


        </>
    )
}

export default PrimeMobile;